module.exports = __webpack_public_path__ + "static/hand2-257378fd32f6b3a8d1e5589b2cb51d2a.webp";